import { render, staticRenderFns } from "./NError.vue?vue&type=template&id=66da709a"
import script from "./NError.vue?vue&type=script&lang=js"
export * from "./NError.vue?vue&type=script&lang=js"
import style0 from "./NError.vue?vue&type=style&index=0&id=66da709a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports